/**
 * @file
 * Provide behaviors to enhance the jQuery UI dialogs.
 *
 * @todo: Remove if the modal has been replaced by sdc aw:modal everywhere.
 */

/**
 * Implement a function to adjust height of images inside
 * the '.ui-dialog--modal'.
 */
(function ($, Drupal) {
  /**
   * Show ajaxProgressThrobber for buttons
   */
  Drupal.behaviors.uiDialogFormButtons = {
    attach: function (context) {
      once('show-ajax-throbber', '.js-show-throbber', context).forEach(function(currentElement){
        currentElement.addEventListener('click', function() {
          let specClass = [...this.classList][0];
          let button = $('.ui-dialog-buttonset').find('.' + specClass);

          button.wrap("<div class='ajax-button-wrapper'></div>");

          if (button.length) {
            button.after(Drupal.theme.ajaxProgressThrobber());
          } else {
            $(this).after(Drupal.theme.ajaxProgressThrobber());
          }
        });
      });
    }
  };


  Drupal.behaviors.modalAvoidScrollingBackground = {
    attach: function () {
      $(window).on('dialog:aftercreate', function () {
          $('body').addClass('no-scroll');
        })
        .on('dialog:beforeclose', function () {
          $('body').removeClass('no-scroll');
        });
    }
  };

  Drupal.behaviors.closeModal = {
    attach: function(context) {
      once('awCloseModal', '.ui-dialog .js-aw-modal-close').forEach(function(currentElement) {
        currentElement.addEventListener('click', function() {
          let modal = $('#drupal-modal');
          if (modal.dialog('instance') !== 'undefined') {
            modal.dialog('close');
          }
        })
      });
    }
  }
})(jQuery, Drupal);
